import axios from 'axios';
import {config} from '../../config';
import store from "../store";

export class RaceCardService {
    static getRace(raceId, callback) {
        axios.get(`${config.serverUri}/race/${raceId}?token=${store.getters.getUserAuthToken}`)
            .then((response) => {
                callback(response.data[0]);
               
            })
            .catch((error) => {
                if (error.status === 500) return;
                // console.error(error);
            });
    }

    static getStats(raceId, callback) {
        axios.get(`${config.serverUri}/racecardstats/${raceId}?token=${store.getters.getUserAuthToken}`)
            .then((response) => {
                callback(response.data[0]);
            })
            .catch((error) => {
                if (error.status === 500) return;
                // console.error(error);
            });
    }

    static getRaceCardSummaries(callback) {
        
        axios.get(`${config.serverUri}/racecardsummaries?token=${store.getters.getUserAuthToken}`)
            .then((response) => {
                // const raceCardSummaries = RaceCardService.cleanRaceCardSummaries(response);
                callback(response.data);
            })
            .catch((error) => {
                if (error.status === 500) return;
                // console.error(error);
            });
    }

    static getNationalStats(callback) {
        axios.get(`${config.serverUri}/nationalstats?token=${store.getters.getUserAuthToken}`)
            .then((response) => {
                callback(response.data[0]);
            })
            .catch((error) => {
                if (error.status === 500) return;
                // console.error(error);
            });
    }

    static cleanRaceCardSummaries(raceCardSummaryResponse) {
        return raceCardSummaryResponse.data.map((raceCardSummaryItem) => {
            const raceCardSummary = Object.assign({}, raceCardSummaryItem.raceCardSummary);
            raceCardSummary.raceCardId = raceCardSummaryItem.id;
            raceCardSummary.raceCount = raceCardSummaryItem.raceCardSummary.raeceCount;
            return raceCardSummary;
        });
    }
}
